module.exports = __webpack_public_path__ + "static/img/8_03.a749c1e2.png";